import { createAction } from 'redux-actions';

/**
 * action login
 */
export const LoginRequested = createAction('LOGIN_REQUESTED');
export const LoginReceived = createAction('LOGIN_RECEIVED');
export const LoginReceiveFailure = createAction('LOGIN_RECEIVE_FAILURE');
export const LoginReproduced = createAction('LOGIN_REPRODUCED'); // reproduced login info from cookie to redux store

/**
 * action logout
 */
export const LogoutRequested = createAction('LOGOUT_REQUESTED');
export const LogoutRequestedReceived = createAction('LOGOUT_REQUESTED_RECEIVED');
export const LogoutRequestedReceivedFailure = createAction('LOGOUT_REQUESTED_RECEIVED_FAILURE');

/**
 * action confirm auth expired
 */

export const AuthExpireConfirmed = createAction('AUTH_EXPIRED_CONFIRMED');

/**
 * waiting get auth in store
 */
export const WaitingAuthorizedCheck = createAction('WAITING_AUTHORIZED_CHECK');

/**
 * free login
 */
export const FreeLoginRequested = createAction('FREE_LOGIN_REQUESTED');

/*
 * show dialog auth expired and click back to login page
 */
export const SetShowDialogAuth = createAction('SET_SHOW_DIALOG_AUTH');
